import React, { memo } from 'react';
import { Text } from 'core/components';
import { inject } from 'mobx-react';
import Markdown from 'app/components/markdown/Markdown';
import { MessageItem, UserMessageBubble, MessageHeader, Timestamp } from '../KaizenChatSession.styles';
import { extractUserPrompt } from '../util/userPrompt';

// Memoized user message component
const UserMessage = memo(({ message, formatDate }) => {
  // Check if the message contains context (regex matched)
  const displayText = extractUserPrompt(message.message_text);

  return (
    <MessageItem key={`user-${message.id}`}>
      <UserMessageBubble>
        <MessageHeader isUser>
          <Text>{message.user?.user_full_name || 'User'}</Text>
          <Timestamp isUser>{formatDate(message?.created_at || new Date())}</Timestamp>
        </MessageHeader>
        <Markdown allowMermaid={false}>{displayText}</Markdown>
      </UserMessageBubble>
    </MessageItem>
  );
});

UserMessage.displayName = 'UserMessage';

export default inject('$auth')(UserMessage);
